'use client'

import { useState, useRef, useEffect } from 'react'

type ExpandableTextProps = {
  text: string
  maxLines?: number
  className?: string
}

export function ExpandableText({ text, maxLines = 4, className }: ExpandableTextProps) {
  const [isExpanded, setIsExpanded] = useState(false)
  const [isOverflowing, setIsOverflowing] = useState(false)
  const textRef = useRef<HTMLParagraphElement>(null)

  useEffect(() => {
    const el = textRef.current
    if (!el) return

    const checkOverflow = () => {
      setIsOverflowing(el.scrollHeight > el.clientHeight)
    }

    checkOverflow()

    const observer = new ResizeObserver(checkOverflow)
    observer.observe(el)
    return () => observer.disconnect()
  }, [text])

  const lineClampClass = !isExpanded ? `line-clamp-${maxLines}` : ''

  return (
    <div>
      <p
        ref={textRef}
        className={`text-neutral leading-relaxed whitespace-pre-line ${lineClampClass} ${className ?? ''}`}
        style={!isExpanded ? { WebkitLineClamp: maxLines, display: '-webkit-box', WebkitBoxOrient: 'vertical', overflow: 'hidden' } : undefined}
      >
        {text}
      </p>
      {(isOverflowing || isExpanded) && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-2 text-sm font-medium text-[#DE866D] hover:text-[#235a52] transition-colors"
        >
          {isExpanded ? 'See less' : 'See more'}
        </button>
      )}
    </div>
  )
}
